import { Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import { Page } from "@/components";
import type { InternLenke } from "@/components/LenkerContainer";
import { DokumentasjonsLenker } from "../dokumentasjon/DokumentasjonsLenker";
import { VeiledningLenke } from "../shared/VeiledningLenke";
import BestillingListe from "./BestillingListe";
import { FjernAvtaleLink } from "./FjernAvtaleLink";

export const BestillingPage = () => {
  const { t } = useTranslation();
  const dokumentasjonsLenker: InternLenke[] = [
    {
      href: "/dokumentasjon/eksporter",
      text: t("pages.dokumentasjon.lenker.avtale-eksport"),
      external: false,
    },
  ];
  return (
    <Page>
      <div className="flex flex-col gap-4 xl:flex-row xl:justify-between">
        <div className="max-w-card w-full space-y-6">
          <Heading data-size="md">{t("pages.bestillinger.tittel")}</Heading>
          <Paragraph>{t("pages.bestillinger.beskrivelse")}</Paragraph>
          <BestillingListe />
        </div>
        <div className="max-w-small-card space-y-6">
          <FjernAvtaleLink />
          <VeiledningLenke />
          <DokumentasjonsLenker lenker={dokumentasjonsLenker} />
        </div>
      </div>
    </Page>
  );
};
